const useEventMsg1004CrossDay = () => {
  return (event) => {
    const eventData = JSON.parse(event.data)
    console.info(`useEventMsg1004CrossDay=============${eventData}============`)
  }
}

export default useEventMsg1004CrossDay
